module.exports = __webpack_public_path__ + "img/grass-tile-0000.b6994a99.jpg";